import React from 'react';
import { withRouter } from "react-router-dom";
import { SlPageTitle, SlButton } from '../editors';
import { Row, Col } from "reactstrap";
import { metadataService } from '../../_services';
import { connect } from "react-redux";

const noOffers = (props) => {

    const handleContinue = () => {
        props.history.push("/")
    }

    return (
        <div>
            <SlPageTitle pageName="NoOffers" />
            <Row>
                <Col>
                    <p className={"text-center"}>{metadataService.getMessage("NoOffers")}</p>
                    <div className={"text-center"}>
                        <SlButton name={"Close"} size={"lg"} className={"text-center"} onClick={handleContinue} />
                    </div>
                </Col>
            </Row>
        </div>
    )

};

function mapStateToProps(store) {

    const { language } = store.users;



    return {
        language
    };
}

const NoOffers = withRouter(noOffers);
const connectedNoOffers = connect(mapStateToProps)(NoOffers);
export { connectedNoOffers as NoOffers };
